import { collection, type Reference } from "@doitintl/models-types";

import { type CustomerModel } from "./Customer";

@collection("realtime")
export class RealtimeBucketInfoModel {
  accountId!: string;

  bucketId!: string;

  bucketName!: string;

  customerRef!: Reference<CustomerModel>;

  region?: string;

  roleArn!: string;

  RoleName!: string;
}
